import { createStyles } from '../../core/withStyles';
const styles = (theme) => createStyles({
    root: {
        maxWidth: '100%',
        width: theme.logo.width,
    },
    square: {
        width: theme.logo.squareWidth,
    },
});
export default styles;
//# sourceMappingURL=Logo.styles.js.map